import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useIsSellerFeatureEnabled = (featureCode) => {
  const { isExpired: isSubscriptionExpired } = useSelector(Global.selectSellerSubscriptionPlanInfo) || {};
  const sellerFeatures = useSelector(Global.selectSellerSellerFeatures);

  if (isSubscriptionExpired) {
    return false;
  }

  const enabledFeaturesAndAddOnsCodes = new Set(sellerFeatures);
  return enabledFeaturesAndAddOnsCodes.has(featureCode);
};
